import { render, staticRenderFns } from "./PaytmPG.vue?vue&type=template&id=4ffebb1b&scoped=true&"
import script from "./PaytmPG.vue?vue&type=script&lang=js&"
export * from "./PaytmPG.vue?vue&type=script&lang=js&"
import style0 from "./PaytmPG.vue?vue&type=style&index=0&id=4ffebb1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffebb1b",
  null
  
)

export default component.exports